import React, { useEffect, useState } from "react";
import "../assets/OnboardLicense.css";
import "../assets/CreateSolution.css";
import { fetchData, postData} from "../api/restapi";
import Select from "react-select";
import Popup from "../popups/popup";
import ConfirmationDialog from "../popups/ConfirmationDialog";

function SolutionTab() {
  const [licenseOptions, setLicenseOptions] = useState([]);
  const [mbnOptions, setMbnOptions] = useState([]);
  const [rows, setRows] = useState([{ license: null, action: null }]);
  const [mbn, setMbn] = useState(null);
  const [inputText, setInputText] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = () => {
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    const data = {
      user: "Srivatsa",
      description: inputText,
      licenses: rows
        .filter((row) => row.license && row.action)
        .map((row) => ({
          licenseId: row.license.value,
          action: row.action.value
        })),
      ...(mbn ? { mbnFileId: mbn.value } : {})
    };

    postData("/qfm/v1/solutions/manage", data)
      .then((response) => {
        if (response.error) {
          setErrorMessage(response.error);
        } else {
          setSuccessMessage("Created Solution Successfully!");
        }
      })
      .catch((err) => setErrorMessage("There was an error encountered: " + err.message));

    setShowConfirmation(false);
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  const closePopup = () => {
    setSuccessMessage("");
    setErrorMessage("");
    window.location.reload();
  };

  useEffect(() => {
    fetchData("/qfm/v1/solutions/portal/licenses")
      .then((data) => {
        setLicenseOptions(
          data?.licenses.map((item) => ({
            value: item.licenseId,
            label: `${item.licenseId}: ${item.description}`
          })) || []
        );
      });

    fetchData("/qfm/v1/solutions/portal/mbns")
      .then((data) => {
        setMbnOptions(
          data?.mbns.map((item) => ({
            value: item.mbnFileId,
            label: `${item.mbnFileId}: ${item.description}`
          })) || []
        );
      });
  }, []);

  const handleAddRow = () => {
    setRows([...rows, { license: null, action: null }]);
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
  };

  return (
    <div className="lsn-tab-container">
      <div className="tab-heading">
        <h1>Create New Solution</h1>
      </div>

      <div className="row">
        <div className="dropdown-section">
          <div className='dropdown-heading'>Description<span className="required-asterisk">*</span></div>
          <input
            type="text"
            placeholder="Enter text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
          />
        </div>
      </div>

      <div className="spacing"></div>

      {rows.map((row, index) => (
        <div className="row" key={index}>
          <div className="dropdown-section">
            <div className='dropdown-heading'>License</div>
            <Select
              className="dropdown multi-select"
              options={licenseOptions}
              value={row.license}
              onChange={(value) => handleRowChange(index, "license", value)}
              placeholder="Select..."
            />
          </div>

          <div className="dropdown-section">
            <div className='dropdown-heading'>Action</div>
            <Select
              className="dropdown multi-select"
              options={[
                { value: "1", label: "Install" },
                { value: "2", label: "Uninstall" },
              ]}
              value={row.action}
              onChange={(value) => handleRowChange(index, "action", value)}
              placeholder="Select..."
            />
          </div>
          <button className="add-row-button" onClick={handleAddRow}>+ Add License</button>
        </div>
      ))}

      <div className="row">
        <div className="dropdown-section">
          <div className='dropdown-heading'>Delta MBN</div>
          <Select
            className="dropdown multi-select"
            options={mbnOptions}
            value={mbn}
            onChange={setMbn}
            placeholder="Select..."
          />
        </div>
      </div>

      <div className='submit-button-section'>
        <button className="submit-button" onClick={handleSubmit}>Create Solution</button>
      </div>

      {showConfirmation && (
        <ConfirmationDialog
          message={`Are you sure you want to create the following Solution?\n\nSolution Description: ${inputText || "None"}\nLicenses: ${rows.map((row) => `\n - Action: ${row.action?.label || "None"}, License: ${row.license?.label || "None"}`).join("")}\nDelta MBN: ${mbn?.label || "None"}`}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}

      {successMessage && (
        <Popup message={successMessage} onClose={closePopup} />
      )}

      {errorMessage && (
        <Popup message={errorMessage} onClose={closePopup} />
      )}
    </div>
  );
}

export default SolutionTab;
